export default __webpack_public_path__ + "static/media/cbr2.33c76222.PNG";